import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { connect, partnerConnect } from '../../models/connect.models';

@Injectable({
  providedIn: 'root'
})
export class LeadService {

  constructor(private http: HttpClient) { }

  contact(connectRequest: connect): Promise<any>
  {
     const contactEndpoint =  "https://api.ewns.in" + "/api/Admin/connect";
     return this.http.post(contactEndpoint,connectRequest, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    } ).toPromise();
  }

  partnerContact(connectRequest: partnerConnect): Promise<any>
  {
    const  partnercontactEndpoint =  "https://api.ewns.in" + "/api/Admin/connect/partner";
    return this.http.post(partnercontactEndpoint,connectRequest, {
     headers: new HttpHeaders()
       .set('Content-Type', 'application/json')
   } ).toPromise();
  }
}
